module.exports = __webpack_public_path__ + "img/niviuk.29501976.png";